import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MmDialogData, MmDialogRefService } from '@metromarkets/components';
import { select, Store } from '@ngrx/store';
import { DocumentFile } from '../../models/document-file.model';
import { State } from '../../store';
import {
  getReceiveDocumentsError,
  getReceiveDocumentsLoading,
  getReceiveDocumentsSuccess,
  ReceiveDocumentGetLink
} from '../../store/receive-document-link';
import { DocumentTypes, ORDER_DETAILS_GET_DOCUMENT_DATE_FORMAT } from '../../constants';

const lengthForFilenameSplitting = 6;

@Component({
  selector: 'app-documents-dialog',
  templateUrl: './document-dialog.component.html',
  styleUrls: ['./document-dialog.component.scss']
})
export class DocumentDialogComponent implements OnInit {
  public files: DocumentFile[];
  public loading$ = this.store$.pipe(select(getReceiveDocumentsLoading));
  public success$ = this.store$.pipe(select(getReceiveDocumentsSuccess));
  public error$ = this.store$.pipe(select(getReceiveDocumentsError));
  public readonly dateFormat = ORDER_DETAILS_GET_DOCUMENT_DATE_FORMAT;
  public readonly docTypes = DocumentTypes;

  constructor (@Optional() public dialogRef: MmDialogRefService<any>,
               @Inject(MmDialogData) public data: {
                 files: DocumentFile[];
                 type: string,
               }, private store$: Store<State>) {
  }

  ngOnInit (): void {
    this.files = this.data.files.map((file) => {
      return {
        ...file,
        shortMimeType: file.mimeType.split('/')[1],
        nameArr: [file.name
          .slice(0, -lengthForFilenameSplitting), file.name.slice(-lengthForFilenameSplitting)],
      };
    });
  }

  downloadDocument (file: DocumentFile) {
    const { id, name, type } = file;

    this.store$.dispatch(new ReceiveDocumentGetLink({ id, name, type }));
  }

  onClose () {
    this.dialogRef.close();
  }
}
